import gCard from "@/components/g-card/g-card.vue"

export default {
  name:'Ajuda',

  components: { 
    gCard,
  }, 

  props: { },

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { }, 

};

